import React, { useEffect, useState } from "react";
import '../styles/Form.css';
import FormInput from '../components/FormInput';
import FormRow from "./FormRow";
import FormSelect from "./FormSelect";
import FormDate from "./FormDate";
import Row from "./Row";  
import FormRadio from "./FormRadio";
import { Api } from '../api/Api';
import { Button, Input, Spin } from "antd";
import Loader from "./Loader";
import { showToast } from "../helpers/Helper";
import Success from "./Success";
import { Modal } from "antd";
import refresh from '../assets/images/sync-alt-solid.svg';

const Form = (props) => {
    const [patient, setPatient] = useState({
        prefix: '',
        firstname: '',
        lastname: '',
        dateofbirth: '',
        age: '',
        gender: '',
        phone_number: '',
        marrital_status: '',
        aadharno: '',
        aabhano:'',
        address: '',
        passportno: '',
        pincode: '',
        locality: '',
        country: '',
        state: '',
        district: '',
        email: '',
        isED: true,
        registrationType: '1',
        ageunitvalue: '',
        emergency_person: '',
        emergency_number: '',
        houseno: '',

        // Add other form fields here...
    });
    const [prefixList, setPrefixList] = useState([]);
    const [genderList, setGenderList] = useState([]);
    const [maritalsList, setMaritalList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [statesList, setStatesList] = useState([]);
    const [countriesList, setCountriesList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [preloaded, setPreloaded] = useState(false);
    const [queueNo, setQueueNo] = useState(null);
    const [showSuccess, setShowSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [captcha, setCaptcha] = useState('');
    const [prefixGenderMap, setPrefixGenderMap] = useState({});
    const showMalayalam = process.env.REACT_APP_MALAYALAM_FONT=='true';
    const setAgeAndUnit = (dateString) => {
        const [day, month, year] = dateString.split('-').map(Number);
        const birthDate = new Date(year, month - 1, day);
    
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        let monthDiff = today.getMonth() - birthDate.getMonth();
        let dayDiff = today.getDate() - birthDate.getDate();
    
        if (dayDiff < 0) {
            monthDiff--;
            dayDiff += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
        }
        if (monthDiff < 0) {
            age--;
            monthDiff += 12;
        }
        const ageToSet = (age !== 0 ? age : (monthDiff !== 0 ? monthDiff : dayDiff));
        const unit = (age !== 0 ? 1 : (monthDiff !== 0 ? 2 : 3));
        setPatient({ ...patient, dateofbirth: dateString, age: ageToSet, ageunitvalue: unit });
    }

    const dobOnchange = (dob) => {
        if (dob) {
            setAgeAndUnit(dob);
        } else {
            setPatient({ ...patient, dateofbirth: '', age: '', ageunitvalue: 1 });
        }
    }
    const allowNumbers = (input) => {
        return input.replace(/\D/g, '');;
    }
    const validateEmail = (email) => {
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(email);
    };
    const validate = () => {
        if (!patient.prefix) {
            showToast('error', 'Prefix is required.');
            return false;
        }
        if (!patient.firstname) {
            showToast('error', 'Firstname is required');
            return false;
        }
        if (!patient.lastname) {
            showToast('error', 'Lastname is required');
            return false;
        }
        if (!patient.dateofbirth && !patient.age) {
            showToast('error', 'Date of birth or Age is required');
            return false;
        }
        if (!patient.gender) {
            showToast('error', 'Gender is required');
            return false;
        }
        if (!patient.phone_number) {
            showToast('error', 'Mobile number is required');
            return false;
        }
        if (process.env.REACT_APP_CLIENT_NAME!=='mosc') {
            if (patient.email && !validateEmail(patient.email)) {
                showToast('error', 'Please enter a valid email');
                return false;
            }
        }
        if (!patient.address) {
            showToast('error', 'House name is required');
            return false;
        }
        if (!patient.locality) {
            showToast('error', 'Street is required');
            return false;
        }
        if (!patient.district) {
            showToast('error', 'District is required');
            return false;
        }
        if (!patient.state) {
            showToast('error', 'State is required');
            return false;
        }
        if (!patient.country) {
            showToast('error', 'Country is required');
            return false;
        }
        if (!patient.pincode) {
            showToast('error', 'Pin code is required');
            return false;
        }
        if (patient.phone_number.length!==10) {
            showToast('error', 'Please enter a valid mobile number');
            return false;
        }
        if (patient.aabhano && patient.aabhano.length!==14){
            showToast('error','Please enter a valid ABHA number');
            return false;
        }
        return true;
    }
    const loadCaptcha = () => {
        Api.get(`/registration/getcaptcha?mobileNo=${patient.phone_number}`).then((resp) => {
            if (resp.status === 200 && resp.data.status === 'success') {
                setCaptcha(resp.data.captchaImage);
            } else {
                showToast('error','Failed to load captcha')    
            }
        }).catch((e) => {
            showToast('error','Failed to load captcha')
        })
    }
    const onSubmit = () => {
        setCaptcha('');
        if (validate()) {
            if (process.env.REACT_APP_DISABLE_CAPTCHA==='false') {
                setShowModal(true);
                loadCaptcha();
            } else {
                onconfirm();
            }
        }
    }   
    const onconfirm = () => {
        setIsSubmitting(true);
        Api.post((process.env.REACT_APP_DISABLE_CAPTCHA==='false' ? '/registration/ApiWebRegistrationInterface' : '/registration/ApiWebRegistrationInterfaceNoCaptcha'), { save_webRegistration: [patient] }).then((resp) => {
            console.log(resp);
            if (resp.status === 200 && resp.data) {
                if (resp.data.response!=='error') {
                    setQueueNo(resp.data.regno);
                    setShowSuccess(true);
                } else {
                    showToast('error', process.env.REACT_APP_DISABLE_CAPTCHA==='false' ? 'Wrong captcha entered.' : 'Error occured.');
                    loadCaptcha();
                }
            } else {
                showToast('error', 'Error submitting data');
                loadCaptcha();
            }
            setIsSubmitting(false);
        }).catch((e) => {
            console.log(e)
            showToast('error', 'Error submitting data,Please check network');
            loadCaptcha();
            setIsSubmitting(false);
        })
    }
    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    }
    const setAutoGender = (value)=>{
        try{
            if (prefixGenderMap[value]) {
                setPatient({ ...patient, gender: prefixGenderMap[value] ,prefix: value });
            } else {
                setPatient({ ...patient,prefix: value });
            }
        }catch(e){

        }
    }
    useEffect(() => {
        if (!preloaded) {
            setIsLoading(true);
            Api.get('/registration/ApiRegistrationdefaultvalues').then((resp) => {
                console.log(resp);
                if (resp.status === 200) {
                    const mapValues = (data, idKey, labelKey) =>
                        data.map(item => ({ value: item[idKey], label: item[labelKey] }));
                    setPrefixList(mapValues(resp.data.prefix_values, 'id', 'prefix'));
                    setGenderList(mapValues(resp.data.gender_values, 'id', 'value'));
                    setMaritalList(mapValues(resp.data.marital_values, 'id', 'value'));
                    setDistrictList(mapValues(resp.data.district_values, 'district_id', 'District_name'));
                    setStatesList(mapValues(resp.data.state_values, 'state_id', 'state_name'));
                    setCountriesList(mapValues(resp.data.country_values, 'id', 'nationality'));
                    setPatient({ ...patient, ageunitvalue: 1,
                        country: resp.data.country_values[0]?.id || '',
                        state: resp.data.state_values[12]?.state_id || '',
                        district: resp.data.district_values[1]?.district_id || ''
                     });
                    console.log(resp.data.gender_values);
                    const prefixGender = {};
                    for (const a of resp.data.prefix_values) {
                        if (a.gender) {
                            prefixGender[a.id] = a.gender;
                        }
                    }
                    setPrefixGenderMap(prefixGender);
                    setPreloaded(true);
                }
                setIsLoading(false);
            }).catch((e) => {
                showToast('error', 'Failed to load resources.')
                setIsLoading(false);
            })
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [])
    return (
        <>
            {isLoading ? <Loader /> : <>{!showSuccess ? 
                <div className="form-container">
                    <div className="title-container">
                        <div className="main-title">
                            <span>Pre-Registration Form</span>
                        </div>
                        <div className="sub-title">
                            <span>NB: The given information will be kept for medical purposes. Kindly provide accurate information.</span>
                        </div>
                    </div>
                    <div className="form-fields">
                        <FormRow>
                            <FormSelect mandatory={true} label={showMalayalam ? "Prefix/പ്രിഫിക്സ്" : "Prefix"} placeholder="Prefix" options={prefixList} value={patient.prefix} onchange={(value) => {  setAutoGender(value); }} />
                            <FormInput mandatory={true} label={showMalayalam ? "First Name/പേര്" : "First Name"} noNumbers={true} placeholder="First Name" value={patient.firstname} onchange={(value) => { setPatient({ ...patient, firstname: value }) }} />
                            <FormInput mandatory={true} label={showMalayalam ? "Last Name/അവസാന പേര്" : "Last Name"} noNumbers={true} placeholder="Last Name" value={patient.lastname} onchange={(value) => { setPatient({ ...patient, lastname: value }) }} />
                        </FormRow>
                        <Row>
                            <FormDate mandatory={true} label={showMalayalam ? "Date of Birth/ജനനത്തീയതി" : "Date of Birth"} maxDate={formatDate(new Date())} value={patient.dateofbirth} onchange={(value) => { setPatient({ ...patient, dateofbirth: value }); dobOnchange(value); }} />
                            <FormInput mandatory={true} label={showMalayalam ? "Age/വയസ്സ്" : "Age"} placeholder="Age" style={{ width: '300px' }} value={patient.age} onchange={(value) => { setPatient({ ...patient, age: value }) }} disabled={patient.dateofbirth ? true : false} />
                            <FormSelect label={showMalayalam ? "Unit/യൂണിറ്റ്" : "Unit"} placeholder="Unit" options={[{ value: 1, label: 'Year' }, { value: 2, label: 'Month' }, { value: 3, label: 'Days' }]} disabled={patient.dateofbirth ? true : false}
                                value={patient.ageunitvalue} onchange={(value) => { setPatient({ ...patient, ageunitvalue: value }) }} />
                        </Row>
                        <FormRow>
                            <FormRadio mandatory={true} label={showMalayalam ? "Gender/ലിംഗം" : "Gender"} options={genderList} value={patient.gender} onchange={(value) => { setPatient({ ...patient, gender: value }) }} />
                        </FormRow>
                        {process.env.REACT_APP_CLIENT_NAME==="mosc" ?
                            <FormRow>
                                <FormInput label={showMalayalam ? "Aadhaar Number/ആധാർ നമ്പർ" : "Aadhaar Number"} inputMode="numeric" maxLength={12} placeholder="Aadhaar Number" value={patient.aadharno} onchange={(value) => { setPatient({ ...patient, aadharno: value }) }} />
                                <FormInput label={showMalayalam ? "ABHA Number/ആഭാ നമ്പർ" : "ABHA Number"}  inputMode="numeric" maxLength={14} placeholder="ABHA Number" value={patient.aabhano} onchange={(value) => { setPatient({ ...patient, aabhano: value }) }} />
                                <FormInput label={showMalayalam ? "Passport Number/പാസ്പോർട്ട് നമ്പർ" : "Passport Number"} placeholder="Passport Number" value={patient.passportno} onchange={(value) => { setPatient({ ...patient, passportno: value }) }} />
                            </FormRow> 
                            : <></>
                        }
                        <FormRow>
                            <FormInput mandatory={true} inputMode="numeric" maxLength={10} label={showMalayalam ? "Mobile Number/മൊബൈൽ നമ്പർ" : "Mobile Number"} placeholder="Mobile Number" value={patient.phone_number} onchange={(value) => { setPatient({ ...patient, phone_number: allowNumbers(value) }) }} />
                            <FormInput label={showMalayalam ? "Email/ഇമെയിൽ" : "Email"} placeholder="Email" value={patient.email} onchange={(value) => { setPatient({ ...patient, email: value }) }} />
                        </FormRow>
                        <FormRow>
                            <FormSelect label={showMalayalam ? "Marital Status/വൈവാഹിക സ്ഥിതി" : "Marital Status"} placeholder="Marital Status" options={maritalsList} value={patient.marrital_status} onchange={(value) => { setPatient({ ...patient, marrital_status: value }) }} />
                            <FormInput mandatory={true} label={showMalayalam ? "House Name/വീട്ടുപേര്" : "House Name"} placeholder="House Name" value={patient.address} onchange={(value) => { setPatient({ ...patient, address: value }) }} />
                        </FormRow>
                        <FormRow>
                            <FormSelect mandatory={true} label={showMalayalam ? "Country/രാജ്യം" : "Country"} placeholder="Country" options={countriesList} value={patient.country} onchange={(value) => { setPatient({ ...patient, country: value }) }} />
                            <FormSelect mandatory={true} label={showMalayalam ? "State/സംസ്ഥാനം" : "State"} placeholder="State" options={statesList} value={patient.state} onchange={(value) => { setPatient({ ...patient, state: value }) }} />
                        </FormRow>
                        <FormRow>
                            <FormSelect mandatory={true} label={showMalayalam ? "District/ജില്ല" : "District"} placeholder="District" options={districtList} value={patient.district} onchange={(value) => { setPatient({ ...patient, district: value }) }} />
                            <FormInput mandatory={true} label={showMalayalam ? "Street/സ്ഥലം" : "Street"} placeholder="Street" value={patient.locality} onchange={(value) => { setPatient({ ...patient, locality: value }) }} />
                            <FormInput mandatory={true} inputMode="numeric" maxLength={6} label={showMalayalam ? "Pin Code/പിൻ കോഡ്" : "Pin Code"} placeholder="Pin Code" value={patient.pincode} onchange={(value) => { setPatient({ ...patient, pincode: allowNumbers(value) }) }} />
                        </FormRow>
                        
                        <div className="submit-btn-container">
                            <Button style={{ backgroundColor: 'var(--primary-accent)', color: 'white' }} onClick={onSubmit}>{isSubmitting ? <Spin></Spin> : 'Submit'}</Button>
                        </div>
                    </div>
                    <div className="branding">Powered by Life HIS</div>
                    <Modal title="Enter Captcha" open={showModal} footer={null} closable={true} maskClosable={false} onCancel={() => { setShowModal(false);setCaptcha(''); }}>
                        {captcha ? <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start',margin:'10px' }}>
                            <img src={'data:image/png;base64,' + captcha} alt="captcha" />
                            <img style={{ marginLeft: '20px', width:'20px',height:'20px',cursor:'pointer'}} src={refresh} onClick={loadCaptcha} alt="Reload"/>
                        </div> : <Spin></Spin>}
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center'}}>
                            <Input style={{ margin: '10px 10px' }} onChange={(e) => { setPatient(prev => ({...prev,captcha:e.target.value}))}}/>
                            <Button onClick={() => { onconfirm(); }} style={{ backgroundColor: '#5F0A10', color: 'white', margin: '10px 0' }} >{isSubmitting ? <Spin></Spin> : 'Submit'}</Button>
                        </div>
                    </Modal>
                </div> :
                <Success queueNo={queueNo}/>}</>
            }
        </>
    )
}
export default Form;